import React from "react";
import { Container, Row, Col } from "reactstrap";

function Testimonials() {
  const size =
    document.body.clientWidth >= 1024 || document.documentElement.clientWidth >= 1024
      ? true
      : false;

  return (
    <section id="testimonials" className="pb-5">
      <Container>
        <Row className="justify-content-center">
          <Col lg={10}>
            <h2
              className="text-center text-white mb-4"
              style={{
                fontSize: size ? "2.5rem" : "1.8rem",
                letterSpacing: "0.04em",
              }}
            >
              TESTIMONIALS
            </h2>
            <Row>
              {testimonials.map((item) => (
                <Col md={6} xs={12} key={item.id} className="mb-3">
                  <div
                    className="iframe-container"
                    style={{
                      position: "relative",
                      width: "100%",
                      paddingTop: "56.25%",
                      borderRadius: "10px",
                      overflow: "hidden",
                    }}
                  >
                    <iframe
                      title={item.title}
                      src={`https://www.youtube.com/embed/${item.id}`}
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        border: 0,
                      }}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen
                    />
                  </div>
                  <p className="text-white mt-3 mb-0">{item.title}</p>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Testimonials;

const testimonials = [
  { id: "KBi41U4UF4Y", title: "" },
  { id: "5ko-XrxUaf8", title: "" },
];
